import Lists from "./lists.service";

const listsModule = angular
  .module("app.services.lists", [])
  .service("Lists", Lists);

export default listsModule;



// WEBPACK FOOTER //
// ./src/services/lists/lists.module.js